<template>
  <div>
    <v-btn
      id="button"
      v-if="!hidden"
      :disabled="disabled"
      :loading="loading"
      v-bind="btnProps"
      v-on="$listeners"
      :min-width="113"
      :text="text"
    >
      <slot />
      <template v-slot:loader>
        <span class="custom-loader mr-2">
          <v-icon dark>mdi-loading</v-icon>
          {{ text }}
        </span>
        <slot />
      </template>
    </v-btn>
  </div>
</template>

<script>
import { VBtn } from "vuetify/lib";
import { mapGetters } from 'vuex'
import Util from "@/components/Util.js";
export default {
  mixins: [VBtn],
  props: {
    color: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    ripple: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: undefined,
    },
    text: {
      type: String,
    },
  },
  computed: {    
    btnProps() {
      const _keys = [
        "color",
        "disabled",
        "hidden",
        "ripple",
        "rounded",
        "loading",
        "style",
      ];
      return Util.filterProps(this, _keys);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.v-btn {
  background: var(--v-brand-primary-base) !important;
  color: #fff;
  font-size: 1.125rem !important;
  margin-bottom: 1.5rem !important;
  line-height: 22px !important;
  font-weight: bold;
  text-transform: none;
  letter-spacing: normal;

  &.brand-primary,
  &.brand-secondary,
  &.brand-tertiary,
  &.feedback-error,
  &.feedback-success,
  &.feedback-info,
  &.feedback-warning,
  &.feedback-link {
    &:not(.v-btn--outlined) {
      color: #fff;
    }

    &:before {
      background-color: #000;
    }
  }
  &:not(.v-btn--round).v-size--default {
    height: 3rem;
    width: 3rem;
    padding: 0 2rem;
  }
  &:not(.v-btn--text):not(.v-btn--outlined) {
    &:hover:before {
      opacity: 0.15;
    }
    &:focus:before {
      opacity: 0.25;
    }
  }
  &--rounded {
    border-radius: 1rem;
  }
}

#button {
  width: 165px;
  height: 48px;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
